import type { BigNumbersFiltersFormProps } from './types'

export const bigNumbersFiltersInitialFormValues: BigNumbersFiltersFormProps = {
  businessUnit: [],
  directorate: [],
  portfolio: [],
  economicGroup: [],
  product: [],
  serviceType: []
}
